var _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XLS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.41,
    height: 19.996,
    viewBox: "0 0 17.41 19.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M27.353,9H22.711V4.357A.357.357,0,0,0,22.354,4h-10A.357.357,0,0,0,12,4.357v19.28a.357.357,0,0,0,.357.357h15a.357.357,0,0,0,.357-.357V9.356A.357.357,0,0,0,27.353,9Z",
    transform: "translate(-10.301 -3.998)",
    fill: "#eee"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6121",
    "data-name": "Rectangle 6121",
    width: 12.765,
    height: 6.874,
    rx: 1,
    transform: "translate(0 9.995)",
    fill: "#2e7d32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4569",
    "data-name": "Path 4569",
    d: "M45.609,9.1l-5-5A.357.357,0,0,0,40,4.353v5a.357.357,0,0,0,.357.357h5a.357.357,0,0,0,.253-.611Z",
    transform: "translate(-28.305 -3.994)",
    fill: "#e0e0e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4571",
    "data-name": "Path 4571",
    d: "M1.388-3.226l.575-1.056h.726L1.8-2.763l.915,1.545H1.977L1.388-2.291.8-1.218H.064L.98-2.763.088-4.282H.814Zm2.7,1.5H5.433v.507H3.461V-4.282h.631Zm3.722-.3a.423.423,0,0,0-.023-.144A.28.28,0,0,0,7.7-2.285a.818.818,0,0,0-.183-.107,2.887,2.887,0,0,0-.3-.112,3.7,3.7,0,0,1-.4-.152,1.46,1.46,0,0,1-.326-.2.887.887,0,0,1-.221-.264.722.722,0,0,1-.081-.349.744.744,0,0,1,.083-.35.79.79,0,0,1,.234-.27,1.148,1.148,0,0,1,.358-.174,1.583,1.583,0,0,1,.456-.062,1.438,1.438,0,0,1,.463.07,1.063,1.063,0,0,1,.356.2.871.871,0,0,1,.227.3.9.9,0,0,1,.08.38H7.817a.509.509,0,0,0-.031-.179A.363.363,0,0,0,7.692-3.7a.436.436,0,0,0-.158-.092.686.686,0,0,0-.223-.033.757.757,0,0,0-.216.027.438.438,0,0,0-.152.076.319.319,0,0,0-.09.114.324.324,0,0,0-.031.139.3.3,0,0,0,.155.254,1.747,1.747,0,0,0,.454.19,2.982,2.982,0,0,1,.441.173,1.311,1.311,0,0,1,.318.215.819.819,0,0,1,.193.269.839.839,0,0,1,.065.339.794.794,0,0,1-.079.36.744.744,0,0,1-.224.266,1.061,1.061,0,0,1-.35.166,1.685,1.685,0,0,1-.458.058,1.769,1.769,0,0,1-.3-.026,1.458,1.458,0,0,1-.289-.081,1.257,1.257,0,0,1-.256-.137.944.944,0,0,1-.205-.194.874.874,0,0,1-.137-.254A.952.952,0,0,1,6.1-2.182h.633a.565.565,0,0,0,.044.236.4.4,0,0,0,.123.157.512.512,0,0,0,.19.087,1.043,1.043,0,0,0,.248.027A.765.765,0,0,0,7.549-1.7.437.437,0,0,0,7.7-1.774a.287.287,0,0,0,.087-.11A.337.337,0,0,0,7.814-2.022Z",
    transform: "translate(2.051 16.182)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/XLS.276204a5ed2abc286d8da79df24897d6.svg";
export { ForwardRef as ReactComponent };